import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementServiceProvider,
} from "../../../ui/authorizedUiElement";
import {
  UserProfile,
  vsName as UserProfileName,
} from "../../../application/UserProfile";
import { StateService } from "@uirouter/angularjs";

export const vsServiceName = "userDetailTabsService";
export const vsProviderName = `${vsServiceName}Provider`;

export class UserDetailTabsServiceProvider extends AuthorizedUiElementServiceProvider<AuthorizedUiElementConfig> {
  $get: any = [
    UserProfileName,
    "$state",
    (userProfile: UserProfile, $state: StateService) => {
      return this.defaultServiceFactory(userProfile, $state);
    },
  ];
  basePath: string = "main.users.detail";
}
